export default "__VITE_ASSET__Q2WBZyEI__"